import Field from '../field/field.m.js';

class ActionField extends Field {
    constructor(...args) {
        const _ = super(...args);
        return _;
    }

    template() {
        return `
			${this.shadowRoot ? this.styles() : ''}
			<label class="${this.shadowClass}">	
				<span label>${this.sanitizeInput(this.label || '')}</span>
				<input input ${this.renderAttributes(['name', 'value', 'disabled', 'placeholder', 'type', 'form', 'list', 'autofocus', 'autocomplete', 'readonly', 'required', 'zsTabindex', 'pattern', 'min', 'max', 'step', 'checked', 'minlength', 'maxlength', 'size', 'multiple', 'alt', 'height', 'width'])}/>
				<span signifier class="${this.iconClass}"></span>
				<a hint href="#" onclick="return false;" class="${this.hintIconClass}"></a>
				<a clear class="${this.clearIconClass}"  href="#" onclick="return false;"></a>
                <a action href="#" onclick="return false;" class="${this.actionIconClass}"></a>
                <span helper>${this.sanitizeInput(this.helperText || '')}</span>
            </label>
		`
    }

    setup() {
        super.setup();
        this.syncProp('hintIcon');
        this.syncProp('actionIcon');
        this.syncProp('helperText');
        this.on(['hint', 'action']);
    }


    get hintIconClass() {
        return (this.isClearVisible || !this.hintIcon) ? 'zs-display-none' : `zs-interactive-primary zs-icon  zs-icon-${this.hintIcon}`
    }

    get clearIconClass() {
        return this.isClearVisible ? 'zs-icon zs-icon-close-circle-fill  zs-interactive-primary' : 'zs-display-none';
    }

    get iconClass() {
        return this.icon ? `zs-icon  zs-icon-${this.icon}` : 'zs-display-none';
    }

    get actionIconClass() {
        return this.actionIcon ? ` zs-interactive-secondary zs-icon  zs-icon-${this.actionIcon}` : 'zs-display-none';
    }

    get signifierElement() {
        return this.root.querySelector('[signifier]');
    }

    get hintElement() {
        return this.root.querySelector('[hint]');
    }

    get actionElement() {
        return this.root.querySelector('[action]');
    }

    get helperElement() {
		return this.root.querySelector('[helper]');
	}
    getPropertyType(name) {
        switch (name) {
            case 'onhint':
            case 'onaction':
                return 'function';
            default:
                return super.getPropertyType(name);
        }
    }

    static get observedAttributes() {
        return super.observedAttributes.concat(['hint-icon', 'action-icon', 'onaction', 'onhint', 'helper-text']);
    }

    propertyChangedCallback(name, oldValue, newValue) {
        if (!this.parentNode && !this.innerHTML) { return; }
        switch (name) {
            case 'icon':
                this.signifierElement ? this.signifierElement.className = this.iconClass : null;
                break;
            case 'clear':
                this.clearIconElement ? this.clearIconElement.className = this.clearIconClass : null;
                break;
            case 'hintIcon':
                this.hintElement ? this.hintElement.className = this.hintIconClass : null;
                break;
            case 'actionIcon':
                this.actionElement ? this.actionElement.className = this.actionIconClass : null;
                break;
            case 'helperText':
                if (this.helperElement) { this.helperElement.innerHTML = this.sanitizeInput(newValue); }
                break;
            case 'value':
                super.propertyChangedCallback(name, oldValue, newValue);
                this.clearIconElement ? this.clearIconElement.className = this.clearIconClass : null;
                this.hintElement ? this.hintElement.className = this.hintIconClass : null;
                this.actionElement ? this.actionElement.className = this.actionIconClass : null
                break;
            default:
                super.propertyChangedCallback(name, oldValue, newValue);
        }
    }



    onclick(event) {
        super.onclick(event);

        if (event.target === this.hintElement) {
            this.fire('hint');
        } else if (event.target === this.actionElement) {
            this.fire('action');
        }
    }
}

ActionField.is = 'zs-action-field';

export default ActionField;
